import { of } from "rxjs";
import { empty } from "rxjs";
import { ofType } from "redux-observable";
import { concat } from "rxjs";
import { mergeMap, concatMap } from "rxjs/operators";
import normalize from "json-api-normalizer";
import { parseError } from "./lib";

import UserService from "../services/userService";

import {
  DELETE_GUEST_PERMISSION_REQUEST_ACTION,
  deleteGuestPermissionSuccess,
  deleteGuestPermissionFailure,
  loadPatientRequest
} from "../ducks/patient";
import {
  loadUsersSuccess,
  loadUsersFailure,
  LOAD_USERS_REQUEST_ACTION,
  SAVE_USER_REQUEST_ACTION,
  saveUserFailure,
  saveUserSuccess,
  DELETE_USER_REQUEST_ACTION,
  deleteUserFailure,
  deleteUserSuccess,
  LOAD_USER_REQUEST_ACTION,
  loadUserSuccess,
  loadUserFailure,
  SAVE_USER_SUCCESS_ACTION,
  SAVE_USER_FAILURE_ACTION,
  saveUserRequest,
  loadAccountRequest,
  SEND_REMINDER_USER_REQUEST_ACTION,
  sendReminderUserSuccess,
  sendReminderUserFailure,
  USER_LOOKUP_REQUEST_ACTION,
  userLookupSuccess,
  userLookupFailure,
  LOAD_DASHBOARD_REQUEST_ACTION,
  loadDashboardSuccess,
  loadDashboardFailure,
  loadCliniciansSuccess,
  loadCliniciansFailure,
  LOAD_CLINICIANS_REQUEST_ACTION
} from "../ducks/data";
import {
  saveUserFormSuccess,
  saveUserFormFailure,
  SAVE_USER_FORM_REQUEST_ACTION,
  SAVE_USER_ACCEPT_TERMS_REQUEST_ACTION,
  saveUserAcceptTermsSuccess,
  saveUserAcceptTermsFailure
} from "../ducks/user";
import { setActiveDialog, setUserState } from "../ducks/app";

const _ = require("lodash");

export const sendReminderUserEpic = (action$, state$) =>
  action$.pipe(
    ofType(SEND_REMINDER_USER_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new UserService();
      return concat(
        service
          .sendReminder(action.payload)
          .then(response => {
            return sendReminderUserSuccess();
          })
          .catch(error => {
            return sendReminderUserFailure(parseError(error));
          }),
        of(setActiveDialog())
      );
    })
  );

export const loadDashboardEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_DASHBOARD_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let userService = new UserService();
      return userService
        .dashboard()
        .then(response => {
          return loadDashboardSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadDashboardFailure(parseError(error));
        });
    })
  );

export const loadUserEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_USER_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let userService = new UserService();
      return userService
        .find(action.payload)
        .then(response => {
          return loadUserSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadUserFailure(parseError(error));
        });
    })
  );

export const loadUsersEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_USERS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let userService = new UserService();
      return userService
        .findAll(action.payload)
        .then(response => {
          return loadUsersSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadUsersFailure(parseError(error));
        });
    })
  );
export const loadCliniciansEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_CLINICIANS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let userService = new UserService();
      return userService
        .findAllClinicians(action.payload)
        .then(response => {
          return loadCliniciansSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadCliniciansFailure(parseError(error));
        });
    })
  );
export const userLookupEpic = (action$, state$) =>
  action$.pipe(
    ofType(USER_LOOKUP_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let userService = new UserService();
      return userService
        .lookup(action.payload)
        .then(response => {
          return userLookupSuccess(normalize(response.data));
        })
        .catch(error => {
          return userLookupFailure(parseError(error));
        });
    })
  );

export const saveUserAcceptTermsEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_USER_ACCEPT_TERMS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let user = state$.value.app.userState;
      let userService = new UserService();
      return userService
        .acceptTerms(user.id)
        .then(response => {
          return saveUserAcceptTermsSuccess();
        })
        .catch(error => {
          return saveUserAcceptTermsFailure(parseError(error));
        });
    })
  );

export const saveUserFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_USER_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(saveUserRequest(action.payload));
    })
  );

export const saveUserFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_USER_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      const users = action.payload.user;
      const user = users.users[Object.keys(users.users)[0]];
      return concat(
        of(saveUserFormSuccess(user.user)),
        user.attributes.accountId
          ? of(loadAccountRequest(user.attributes.accountId))
          : empty(),
        of(setActiveDialog())
      );
    })
  );

export const saveUserFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_USER_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveUserFormFailure(action.payload));
    })
  );

export const saveUserEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_USER_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let user = action.payload;
      let patientId = user.attributes.patientId;
      let service = new UserService();

      return concat(
        service
          .save(user)
          .then(response => {
            let userId = response.data.data.id;
            let role = user.attributes.role;
            let patientConditionId = user.attributes.patientConditionId;

            if (role) {
              response.data.data.attributes.userRoles = role;
              return service
                .addRole(userId, role, patientConditionId)
                .then(roleResponse => {
                  return saveUserSuccess(normalize(response.data));
                })
                .catch(error => {
                  return saveUserFailure(parseError(error));
                });
            } else {
              return saveUserSuccess(normalize(response.data));
            }
          })
          .catch(error => {
            return saveUserFailure(parseError(error));
          }),
        of(setActiveDialog()),
        patientId ? of(loadPatientRequest(patientId)) : empty()
      );
    })
  );

export const saveUserSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_USER_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      const users = action.payload.user;
      const user = users.users[Object.keys(users.users)[0]];

      let userState = state$.value.app.userState;
      if (userState.id === user.id) {
        userState.attributes = user.attributes;
      }
      return of(
        setUserState({
          userState: userState
        })
      );
    })
  );

export const deleteUserEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_USER_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new UserService();
      return concat(
        service
          .archive(action.payload)
          .then(response => {
            return deleteUserSuccess(action.payload);
          })
          .catch(error => {
            return deleteUserFailure(parseError(error));
          }),
        of(setActiveDialog())
      );
    })
  );

export const deleteUserPermissionEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_GUEST_PERMISSION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new UserService();
      let patientId = action.payload.patientId;
      return concat(
        service
          .deletePermission(
            action.payload.id,
            action.payload.patientConditionId
          )
          .then(response => {
            return loadPatientRequest(patientId);
          })
          .catch(error => {
            return deleteGuestPermissionFailure(parseError(error));
          }),
        of(setActiveDialog()),
        of(deleteGuestPermissionSuccess(action.payload))
      );
    })
  );



// WEBPACK FOOTER //
// ./src/epics/users.js